import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.4705 8.79032C13.5842 6.81336 11.6494 4.71813 11.6494 4H10.057C10.057 5.36444 11.9918 7.05415 13.5763 8.35945V8.65515H1V10.3449H13.5723V10.6406C11.9878 11.9501 10.053 13.6356 10.053 15H11.6454C11.6454 14.2819 13.5842 12.1866 16.4665 10.2055L17 9.83794V9.15361L16.4665 8.7861L16.4705 8.79032Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }